import { useMutation } from "react-query";
import paths from "API/paths";
import axiosInstance from "Services/axiosConfig";
import { CreateSegmentsPayload } from "Interfaces/FeatureFlip";

interface CreateSegmentsPayloadP extends CreateSegmentsPayload {
  projectId: string;
}

const createSegment = async (payload: CreateSegmentsPayloadP) => {
  try {
    const url = paths.createSegment();
    const response = await axiosInstance.post(url, { input: payload });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const useCreateSegment = () => {
  return useMutation(createSegment);
};
